




































import { Component, Vue } from 'vue-property-decorator';
import {
  // eslint-disable-next-line no-unused-vars
  INotification,
  NotificationModule,
} from '@/store/modules/notifications';
import Pagination from '@/components/base/Pagination.vue';
import PreLoader from '@/components/base/PreLoader.vue';
import StatusIcon from '@/components/elements/statement/Status/StatusIcon.vue';

@Component({
  components: { StatusIcon, PreLoader, Pagination },
})
export default class Notification extends Vue {
  allNotificationsCount: number | null = 0;
  currentPage = 1;
  pageSize = 15;
  loading: boolean = false;

  async mounted() {
    this.loading = true;
    await this.getData(15, 0);
    NotificationModule.addToListForRead(
      this.createListForRead(NotificationModule.list)!
    );
    this.loading = false;
  }

  destroyed() {
    this.clearListForRead();
  }

  async getData(pageSize: number = 15, pageNumber: number = 0) {
    NotificationModule.changePageSize(pageSize);
    await NotificationModule.changePageNumber(pageNumber);
    await NotificationModule.getUserNotifications();
    this.allNotificationsCount = NotificationModule.totalCount;
  }

  get getNotificationsList() {
    return NotificationModule.list;
  }

  clearListForRead() {
    if (NotificationModule.listForRead) {
      this.readNotification(NotificationModule.listForRead);
    }
  }

  createListForRead(data: INotification[]) {
    if (!data) {
      return null;
    }
    return data.filter((item: INotification) => item.isNew);
  }

  async onChangePage(val: number) {
    this.loading = true;
    await this.readNotification(NotificationModule.listForRead);
    this.currentPage = val;
    await this.getData(this.pageSize, val - 1);
    NotificationModule.addToListForRead(
      this.createListForRead(NotificationModule.list)!
    );
    this.loading = false;
  }

  async onChangeLimit(val: number) {
    this.loading = true;
    this.pageSize = val;
    await this.readNotification(NotificationModule.listForRead);
    this.currentPage = 1;
    await this.getData(val, 0);
    NotificationModule.addToListForRead(
      this.createListForRead(NotificationModule.list)!
    );
    this.loading = false;
  }

  async readNotification(data: INotification[]) {
    if (!data) {
      return;
    }
    const list = data
      .map(function (item: any) {
        if (item.isNew) {
          return item.id;
        }
      })
      .filter((item: any) => item);
    if (list.length > 0) {
      await NotificationModule.sendReadNotifications(list);
      NotificationModule.clearListForRead();
    }
  }
  async readAllNotification() {
    this.loading = true;
    this.currentPage = 1;
    await NotificationModule.sendReadAllNotifications();
    await this.getData(this.pageSize, 0);
    this.loading = false;
  }
}
